import React, { useContext, useRef, useMemo } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';
/**
 * Atoms
 */
import { Listbox } from '../../lab/Listbox';
import RadioButtonGroup from '../../elements/RadioButtonGroup';
import Box from '../../elements/Box';
import Text from '../../elements/Text';
/**
 * Hooks
 */
import { useIsMobileView } from '@front10/utils';

const FlightTypeFilter = (props, ref) => {
  const {
    value,
    labelKey = 'cmp-location-selector-label-flight-type',
    options = [
      { label: 'cmp-journey-type-options-ow', value: 'ONE_WAY' },
      { label: 'cmp-journey-type-options-rt', value: 'ROUND_TRIP' },
      { label: 'cmp-journey-type-options-mc', href: 'https://google.com' }
    ],
    disabled,
    mobileView = false,
    onChange,
    showTitle,
    filterButtonIconProps,
    mobileOrientation = 'horizontal', // horizontal or vertical
    containerStyle,
    titleStyle = {
      fontWeight: 'bold'
    },
    itemsContainerStyle = {},
    itemsStyles = {}
  } = props;

  const {
    translate,
    direction,
    theme: { designTokens }
  } = useContext(Context);

  const title = translate('cmp-flight-type-title', 'Trip Type');
  const [flightTypeValue, setFlightType] = React.useState(value);

  React.useEffect(() => {
    setFlightType(value);
  }, [value]);

  const flightTypeOptions = useMemo(() => {
    return (Array.isArray(options) ? options : []).map((option) => ({
      ...option,
      label: translate(option.label),
      name: translate(option.label)
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translate]);

  let isMobile = useIsMobileView();
  if (mobileView) {
    isMobile = true;
  }

  const listboxRef = useRef(null);

  React.useImperativeHandle(
    ref,
    () => ({
      focusToggleElement: () => {
        listboxRef.current?.focusToggleElement();
      }
    }),
    []
  );

  const desktopLayout = (
    <Listbox
      ref={listboxRef}
      label={translate(labelKey, 'Select Flight Type')}
      placeholder={title}
      options={flightTypeOptions}
      defaultValue={value}
      forcePlaceholder={disabled}
      focusWhenIsShow={false}
      disabled={disabled}
      onChange={(value) => onChange({ value })}
      filterButtonIconProps={filterButtonIconProps}
    />
  );

  const mobileLayout = (
    <Box {...containerStyle}>
      {showTitle ? (
        <Text
          variant="text.fontSize5"
          display="flex"
          alignItems="center"
          paddingLeft="5px"
          paddingBottom="15px"
          {...titleStyle}
        >
          {title}
        </Text>
      ) : null}
      <RadioButtonGroup
        options={flightTypeOptions}
        defaultOption={flightTypeValue}
        onChange={(newFlightType) => {
          setFlightType(newFlightType);
          props.onChange({ value: newFlightType });
        }}
        orientation={mobileOrientation}
        itemsStyle={itemsStyles}
        itemsContainerStyle={itemsContainerStyle}
      />
    </Box>
  );

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>{!isMobile ? desktopLayout : mobileLayout}</ThemeProvider>
    </EmotionCache>
  );
};

export default React.forwardRef(FlightTypeFilter);
